var InteractionTag = /*#__PURE__*/function (InteractionTag) {
  InteractionTag["UNKNOWN"] = "UNKNOWN";
  InteractionTag["SCRIPT"] = "SCRIPT";
  InteractionTag["TRANSACTION"] = "TRANSACTION";
  InteractionTag["GET_TRANSACTION_STATUS"] = "GET_TRANSACTION_STATUS";
  InteractionTag["GET_ACCOUNT"] = "GET_ACCOUNT";
  InteractionTag["GET_EVENTS"] = "GET_EVENTS";
  InteractionTag["PING"] = "PING";
  InteractionTag["GET_TRANSACTION"] = "GET_TRANSACTION";
  InteractionTag["GET_BLOCK"] = "GET_BLOCK";
  InteractionTag["GET_BLOCK_HEADER"] = "GET_BLOCK_HEADER";
  InteractionTag["GET_COLLECTION"] = "GET_COLLECTION";
  InteractionTag["GET_NETWORK_PARAMETERS"] = "GET_NETWORK_PARAMETERS";
  InteractionTag["SUBSCRIBE_EVENTS"] = "SUBSCRIBE_EVENTS";
  InteractionTag["GET_NODE_VERSION_INFO"] = "GET_NODE_VERSION_INFO";
  return InteractionTag;
}({});
var InteractionStatus = /*#__PURE__*/function (InteractionStatus) {
  InteractionStatus["BAD"] = "BAD";
  InteractionStatus["OK"] = "OK";
  return InteractionStatus;
}({});
var TransactionRole = /*#__PURE__*/function (TransactionRole) {
  TransactionRole["AUTHORIZER"] = "authorizer";
  TransactionRole["PAYER"] = "payer";
  TransactionRole["PROPOSER"] = "proposer";
  return TransactionRole;
}({});
var InteractionResolverKind = /*#__PURE__*/function (InteractionResolverKind) {
  InteractionResolverKind["ARGUMENT"] = "ARGUMENT";
  InteractionResolverKind["ACCOUNT"] = "ACCOUNT";
  return InteractionResolverKind;
}({});

var SignatureAlgorithm = /*#__PURE__*/function (SignatureAlgorithm) {
  SignatureAlgorithm[SignatureAlgorithm["ECDSA_P256"] = 1] = "ECDSA_P256";
  SignatureAlgorithm[SignatureAlgorithm["ECDSA_secp256k1"] = 2] = "ECDSA_secp256k1";
  SignatureAlgorithm[SignatureAlgorithm["BLS_BLS12_381"] = 3] = "BLS_BLS12_381";
  return SignatureAlgorithm;
}({});
var HashAlgorithm = /*#__PURE__*/function (HashAlgorithm) {
  HashAlgorithm[HashAlgorithm["SHA2_256"] = 1] = "SHA2_256";
  HashAlgorithm[HashAlgorithm["SHA2_384"] = 2] = "SHA2_384";
  HashAlgorithm[HashAlgorithm["SHA3_256"] = 3] = "SHA3_256";
  HashAlgorithm[HashAlgorithm["SHA3_384"] = 4] = "SHA3_384";
  HashAlgorithm[HashAlgorithm["KMAC128_BLS_BLS12_381"] = 5] = "KMAC128_BLS_BLS12_381";
  return HashAlgorithm;
}({});

export { HashAlgorithm, InteractionResolverKind, InteractionStatus, InteractionTag, SignatureAlgorithm, TransactionRole };
//# sourceMappingURL=typedefs.module.js.map
